import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton,
  Button,
  TextareaAutosize
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DiscussionModal = ({ open, onClose, note, onSubmit }) => {
  const [response, setResponse] = useState('');

  const handleSubmit = () => {
    onSubmit(response);
    setResponse('');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Feedback to Nurse's Note</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Original Note
          </Typography>
          <Typography variant="body1">
            {note?.content}
          </Typography>
        </Box>
        <TextareaAutosize
          minRows={5}
          placeholder="Type in your response..."
          style={{
            width: '100%',
            padding: '10px',
            borderRadius: '4px',
            border: '1px solid #e0e0e0'
          }}
          value={response}
          onChange={(e) => setResponse(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button 
          variant="contained" 
          color="primary"
          onClick={handleSubmit}
          disabled={!response.trim()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DiscussionModal;